/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Quick Schedule Timezone Field
 *
 * @file QuickScheduleTimezoneField.jsx
 * @author Anuja Gaikwad
 * @since 2.0.3
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import AetTimezone from '../common/AetTimeZone';
import Icon from '../icons/Icon';
import { QUICK_SCHEDULE_FORM_TIMEZONE_FIELD_CLASS } from './quickScheduleFormConstants';

const QuickScheduleTimezoneField = ({
  name,
  control,
  label,
  rules,
  options,
  onChange: onChangeCallback
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <AetTimezone
        className={QUICK_SCHEDULE_FORM_TIMEZONE_FIELD_CLASS}
        label={label}
        value={field.value || ''}
        onChange={(value) => {
          field.onChange(value);
          onChangeCallback?.(value);
        }}
        options={options}
        icons={{ timeZone: <Icon name="DropdownCaretDownIcon" style={{ fontSize: 12, width: 10, height: 6 }} /> }}
      />
    )}
  />
);

QuickScheduleTimezoneField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func
};

QuickScheduleTimezoneField.defaultProps = {
  rules: undefined,
  options: [],
  onChange: null
};

export default QuickScheduleTimezoneField;
